import React from 'react';
import { isSafari } from '~utils/helpers';
import Nav from '../nav';
import './style.scss';

function DesktopNavigation() {
    // чтоб не скакала навигация на страницах без скролла
    const isNoScroll = window.location.href.search('/map') !== -1;

    return (
        <div
            className={`desktop-navigation${
                isNoScroll && !isSafari() ? ' no-scroll' : isNoScroll && isSafari() ? ' no-scroll-safari' : ''
            }`}
        >
            <div className="desktop-navigation__wrap">
                <Nav />
            </div>
        </div>
    );
}

export default DesktopNavigation;
export { DesktopNavigation };



// WEBPACK FOOTER //
// ./src/components/navigation/desktop/index.js